import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-modal fira" }


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    quickExit: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function onBackdropClick() {
	if (!props.quickExit) return;
	emit('close');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal-backdrop",
    onClick: _withModifiers(onBackdropClick, ["self"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "icon-button absolute",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("span", { class: "material-symbols-outlined light" }, "close_small", -1)
      ]))]),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})